<template>
  <div class="input-footer-wuk">
    <input-error-wuk v-if="isInvalid" :validator="validator" :manual-error="manualError" />
    <warning-message-wuk v-else-if="warningMessage" :text="warningMessage" />
    <success-text-wuk v-else-if="successText" :text="successText" />
    <help-text-wuk v-else-if="helpText" :text="helpText" />
  </div>
</template>

<script>
import HelpTextWuk from '@ui-kit/components/inputs/footnotes/HelpText.vue';
import SuccessTextWuk from '@ui-kit/components/inputs/footnotes/SuccessText.vue';
import WarningMessageWuk from '@ui-kit/components/inputs/footnotes/WarningMessage.vue';

export default {
  name: 'InputFooter',
  components: {
    HelpTextWuk,
    SuccessTextWuk,
    WarningMessageWuk,
  },
  props: {
    helpText: String,
    successText: String,
    manualError: String,
    warningMessage: String,
    validator: Object,
    isInvalid: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.input-footer-wuk {
  min-height: $input-footer-height;
  margin-top: $input-footer-margin-top-wuk;
  margin-bottom: $input-footer-margin-bottom-wuk;
}
</style>
